module.exports = __webpack_public_path__ + "img/4.1e73a10e.jpg";